import React from "react";
import "./shimmerEffect.scss";

const ShimmerEffect = ({ totalShimmerElement }) => {
  const shimmerElements = () => {
    let items = [];
    for (let i = 0; i < totalShimmerElement; i++) {
      items.push(<li key={i}></li>);
    }
    return items;
  };

  return <ul className="shimmer-list">{shimmerElements()}</ul>;
};

export default ShimmerEffect;
